import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import AuthPage from './pages/AuthPage';
import AuthCallback from './pages/AuthCallback';
import DashboardPage from './pages/DashboardPage';
import CartPage from './pages/CartPage';
import HowItWorksPage from './pages/HowItWorksPage';
import FAQPage from './pages/FAQPage';
import TermsPage from './pages/TermsPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import ThankYouPage from './pages/ThankYouPage';
import OrderStatusPage from './pages/OrderStatusPage';
import SizingGuidePage from './pages/SizingGuidePage';
import CheckoutSuccessPage from './pages/CheckoutSuccessPage';
import AdminPage from './pages/AdminPage';
import ChatWidget from './components/ChatWidget';
import './index.css';

// Router wrapper to handle auth callback
function AppRouter() {
  const location = useLocation();
  
  // If URL contains session_id hash (from Google OAuth redirect),
  // render AuthCallback directly to process it
  const hasSessionId = location.hash?.includes('session_id=') || 
                       window.location.hash?.includes('session_id=');

  if (hasSessionId) {
    return <AuthCallback />;
  }

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/products/:productId" element={<ProductDetailPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/terms-and-conditions" element={<TermsConditionsPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/order-status" element={<OrderStatusPage />} />
        <Route path="/sizing-guide" element={<SizingGuidePage />} />
        <Route path="/sizing" element={<Navigate to="/sizing-guide" replace />} />
        <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/team" element={<Navigate to="/admin" replace />} />
        <Route path="/mgr" element={<Navigate to="/admin" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-white">
            <AppRouter />
            <ChatWidget />
            <Toaster 
              position="top-right" 
              richColors 
              toastOptions={{
                style: {
                  background: '#ffffff',
                  border: '1px solid #e5e5e5',
                  color: '#1a1a1a'
                }
              }}
            />
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
